import { useMutation } from "@apollo/client/react";
import { gql } from "graphql-tag";
import { toast } from "sonner";

export const REMOVE_MEMORY_FACT_MUTATION = gql`
    mutation RemoveMemoryFact($messageId: UUID!, $messageSourceId: UUID!) {
        messageRemoveMemoryFact(messageId: $messageId, messageSourceId: $messageSourceId)
    }
`;

interface UseRemoveMemoryFactOptions {
    messageId: string | null | undefined;
    /** Called after successful removal. */
    onRemoved?: () => void;
}

interface UseRemoveMemoryFactReturn {
    removeMemoryFact: (messageSourceId: string) => void;
    loading: boolean;
}

export function useRemoveMemoryFact({
    messageId,
    onRemoved,
}: UseRemoveMemoryFactOptions): UseRemoveMemoryFactReturn {
    const [mutate, { loading }] = useMutation<{ messageRemoveMemoryFact: boolean }>(
        REMOVE_MEMORY_FACT_MUTATION,
        {
            onError: (error) =>
                toast.error(`Eintrag konnte nicht aus dem Kundenhistorie entfernt werden: ${error.message}`),
            onCompleted: (data) => {
                if (data.messageRemoveMemoryFact) {
                    toast.success("Eintrag aus dem Kundenhistorie entfernt");
                    onRemoved?.();
                } else {
                    toast.error("Eintrag konnte nicht gefunden werden");
                }
            },
        },
    );

    const removeMemoryFact = (messageSourceId: string) => {
        if (!messageId) return;
        void mutate({ variables: { messageId, messageSourceId } });
    };

    return { removeMemoryFact, loading };
}
